import React from 'react'
import { Helmet } from 'react-helmet-async'
import ServicePageTemplate, { ServicePageConfig } from '../../components/templates/ServicePageTemplate'

const fineWineConfig: ServicePageConfig = {
  title: 'Fine Wine - Bespoke Shopping | FGA Prestige',
  description: 'Sourcing rare and exceptional wines from the world\'s most prestigious vineyards through our bespoke shopping service.',
  slug: 'bespoke-shopping/fine-wine',
  heroImage: '/Bespoke Shopping/Retail Partners/FINE WINE/hero.png',
  serviceName: 'FINE WINE',
  whySectionA: {
    title: 'The Cellar Connoisseur\'s Crown Jewels',
    content: 'Step into our cellar and leave the ordinary at the door. We trade only in conversation-stopping Bordeaux—think Château Lafite Rothschild, Latour Margaux, Haut-Brion, Mouton Rothschild (the fabled First Growth quintet) plus right-bank darlings Pétrus and the unicorn Le Pin for the collector who has everything.',
    image: '/Bespoke Shopping/Retail Partners/FINE WINE/body/1.png',
    imageAlt: 'Premium wine collection'
  },
  whySectionC: {
    title: 'Expert Wine Selection',
    content: 'Our certified sommeliers and wine specialists possess extensive knowledge of viticultural regions, vintage variations, and market trends. We evaluate each selection based on terroir expression, winemaking excellence, and investment potential to ensure you acquire wines of exceptional quality and value.',
    image: '/Bespoke Shopping/Retail Partners/FINE WINE/body/2.png',
    imageAlt: 'Wine Expert Selection'
  },
  whySectionB: {
    title: 'Why Choose FGA Prestige for Fine Wine',
    benefits: [
      {
        title: 'Exclusive Access',
        description: 'Private access to allocated wines, library releases, and direct purchases from prestigious estates worldwide.'
      },
      {
        title: 'Expert Curation',
        description: 'Professional selection by certified sommeliers based on quality, provenance, and investment potential.'
      },
      {
        title: 'Proper Storage',
        description: 'Climate-controlled storage and handling to ensure optimal aging conditions and flavor preservation.'
      }
    ],
    image: '/Bespoke Shopping/Retail Partners/FINE WINE/body/3.png',
    imageAlt: 'Premium wine collection'
  },
  masterpieceBackgroundImage: '/Bespoke Shopping/Retail Partners/FINE WINE/CTA_Banner/banner.png'
}

const FineWinePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Fine Wine - Bespoke Shopping | FGA Prestige</title>
        <meta name="description" content="Sourcing rare and exceptional wines from the world\'s most prestigious vineyards through our bespoke shopping service." />
        <meta property="og:title" content="Fine Wine - Bespoke Shopping | FGA Prestige" />
        <meta property="og:description" content="Sourcing rare and exceptional wines from the world\'s most prestigious vineyards through our bespoke shopping service." />
        <meta property="og:url" content="https://fgaprestige.com/bespoke-shopping/fine-wine" />
        <meta property="og:image" content="/Bespoke Shopping/Retail Partners/FINE WINE/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Fine Wine Collection" />
      </Helmet>
      
      <ServicePageTemplate config={fineWineConfig} />
    </>
  )
}

export default FineWinePage